import { LineChart, Line, Tooltip, XAxis } from 'recharts'
import { PieChart, Pie, Cell } from 'recharts'

import React from 'react'

const COLORS = ['#d15637', '#0fd447', 'deepskyblue', '#8884d8']
export interface iRing { data: { name: string, value: number}[] }
export const Ring = ({ data }: iRing) => <PieChart width={200} height={200}>
    <Pie data={data} cx={90} cy={90} innerRadius={60} outerRadius={80} fill="#8884d8" paddingAngle={5} dataKey="value"> 
        { data.map((_, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />) } 
    </Pie>
</PieChart>
  

export const Square = ({ color }: { color: string}) => <svg width={20} height={15} style={{marginRight:5}}>
    <rect width={15} height={15} style={{fill: color}}/>
</svg>

export interface iTinyChart { data: { name: string, Engagement: number}[] }
export const TinyChart = ({ data }: iTinyChart) => <LineChart width={210} height={50} data={data}>
    <Tooltip formatter={(d) => `${d}%`} />
    <XAxis dataKey="text" hide />
    <Line type="monotone" dataKey="Engagement" stroke="#8884d8" strokeWidth={2} dot={false}/>
</LineChart>

